/* eslint-disable functional/no-expression-statement,@typescript-eslint/ban-ts-comment */
import * as Color from "~/Color";
import * as Log from "~/Log";

export const generate = ({
  svg,
  chartWidth,
  chartHeight,
}: Log.Chart.ChartGeneratorProps) => {
  const defs = svg.append("defs");
  const filter = defs
    .append("filter")
    .attr("id", "drop-shadow")
    .attr("height", "250%")
    .attr("width", "250%");

  filter
    .append("feGaussianBlur")
    .attr("in", "SourceAlpha")
    .attr("stdDeviation", 3)
    .attr("result", "blur-out");

  filter
    .append("feOffset")
    .attr("in", "blur-out")
    .attr("dx", 2)
    .attr("dy", 2)
    .attr("result", "shadow");

  filter
    .append("feFlood")
    .attr("in", "shadow")
    .attr("flood-color", Color.denseFog())
    .attr("flood-opacity", "1")
    .attr("result", "offsetColor");

  filter
    .append("feComposite")
    .attr("in", "offsetColor")
    .attr("in2", "shadow")
    .attr("operator", "in")
    .attr("result", "offsetBlur");

  defs
    .append("svg:clipPath")
    .attr("id", "clip")
    .append("svg:rect")
    .attr("width", chartWidth)
    .attr("height", chartHeight)
    .attr("x", 0)
    .attr("y", 0);

  const merge = filter.append("feMerge");
  merge.append("feMergeNode").attr("in", "offsetBlur");
  merge.append("feMergeNode").attr("in", "SourceGraphic");
};
